import React, { Component } from 'react';
import { Card, CardBlock, CardText, CardTitle, Col, Container, Row } from 'reactstrap';
import GuestSettingsCard from './GuestSettings';
import RsvpTable from './RsvpTable';
import Video from './Video';
import './index.css';



class Welcome extends Component {

  render() {
    if (!this.props.invitation) {
      return null;
    }
    return (
      <div id="Welcome">
        <Video videoSrc={this.props.videoSrc}/>
        <Container id="info">
          <div
            id="welcome-event-html"
            style={{
              marginBottom: '3rem',
            }}
            dangerouslySetInnerHTML={{
            __html: this.props.eventInfoHtml,
            }}
          />
          <Row className="justify-content-center">
            <Col className="col-12 col-md-9 col-lg-7 col-xl-6">
              <Card className="card-first">
                <CardBlock>
                  <CardTitle className="mt-3 mb-4" style={{fontSize: '1.75rem', paddingLeft:'.75rem'}}>{this.props.invitation}, will you join us?</CardTitle>
                  <RsvpTable guests={this.props.guests} mealChoices={this.props.mealChoices}/>
                </CardBlock>
              </Card>
              {this.props.sections.map((section, idx) => (
                <Card className="card-second" key={`section${idx}`}>
                  <CardBlock className="text-center">
                    <CardText
                      dangerouslySetInnerHTML={{
                        __html: section.html,
                      }}
                    />
                  </CardBlock>
                </Card>
              ))}
              <GuestSettingsCard guests={this.props.guests} mealChoices={this.props.mealChoices}/>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/Welcome/index.js